'use client';

import { FC, useState } from 'react';
import AppsShelveItem from './apps-shelve-item';
import { OwAppTile } from '../../../interfaces/domain/ow-app-tile.modal';
// -----------------------------------------------------------------------------
interface AppsShelveSearchResults {
  searchResults: OwAppTile[];
}
// -----------------------------------------------------------------------------
const AppsShelveSearchResults: FC<AppsShelveSearchResults> = ({
  searchResults,
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  
  // ---------------------------------------------------------------------------
  // const sortedTiles = visibleApps.map(app => ({ ...app, true: true }))
  //   .sort((a, b) => parseInt(a.SortRank) - parseInt(b.SortRank));

  // ---------------------------------------------------------------------------
  if (!searchResults) {
    return null;
  }

  // ---------------------------------------------------------------------------
  const handleShowTileInfo = (index: number): void => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // ---------------------------------------------------------------------------
  return (
    <section className='apps-list-section list-type'>
      <div className='apps-list-inner'>
        <div className='apps-list-wrapper'>
          <ul className='apps-list'>
            {searchResults
              .filter(app => !app.disabled && !app.hidden)
              .map((tile, index) => {
                return (
                  <AppsShelveItem
                    item={tile as OwAppTile}
                    isOpen={openIndex === index}
                    onClick={() => handleShowTileInfo(index)}
                    key={index}
                  />
                );
              })}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default AppsShelveSearchResults;
